<template>
  <div v-if="dataPermission && dataPermission.includes('CNPS_LEAD_VIEW')">
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Danh sách Leads</h1>
      <div class="float-right btn-group">
        <DraggableTable
          :naming="$route.name"
          v-model="fieldsTable"
          @change="filterTable = $event"
        />
        <button
          class="font-medium f12 btn btn-outline-secondary"
          @click="$router.push({ path: '/add-lead' })"
          v-if="dataPermission && dataPermission.includes('CNPS_LEAD_ADD')"
        >
          <i class="bx bx-plus-circle"></i> Thêm Lead
        </button>
        <button
          class="font-medium f12 btn btn-outline-secondary"
          @click="$router.push({ path: 'import-file-lead' })"
          v-if="dataPermission && dataPermission.includes('CNPS_LEAD_ADD')"
        >
          <i class="bx bx-upload"></i> Nhập file
        </button>
        <button
          class="font-medium f12 btn btn-outline-secondary"
          data-toggle="tooltip"
          data-placement="top"
          title=""
          data-original-title="Xuất Excel"
          @click="exportExcel"
          v-if="dataPermission && dataPermission.includes('CNPS_LEAD_XLS')"
        >
          <i class="bx bx-download"></i><span>&nbsp;</span>Xuất Excel
        </button>
        <button
          v-if="
            selected.length > 0 &&
            dataPermission &&
            dataPermission.includes('CNPS_LEAD_ASSIGN') &&
            isLead(selected[0].status)
          "
          class="font-medium f12 btn btn-outline-secondary"
          @click="assignCaringSale('advise')"
        >
          Gán NV tư vấn
        </button>
        <button
          v-if="
            selected.length > 0 &&
            dataPermission &&
            dataPermission.includes('CNPS_LEAD_ASSIGN') &&
            isLead(selected[0].status)
          "
          class="font-medium f12 btn btn-outline-secondary"
          @click="assignCaringSale('deployment')"
        >
          Gán NV triển khai
        </button>
        <button
          v-if="
            this.selected.length > 0 &&
            dataPermission &&
            dataPermission.includes('CNPS_CSTM_MERCHANT_UPDATE') &&
            selected[0].status === 'POTENTIAL'
          "
          class="font-medium f12 btn btn-outline-secondary"
          @click="merchant_showListStaffModal = true"
        >
          Gán NV triển khai
        </button>
        <button
          v-if="
            this.selected.length > 0 &&
            dataPermission &&
            dataPermission.includes('CNPS_CSTM_MERCHANT_UPDATE') &&
            selected[0].status === 'MERCHANT'
          "
          class="font-medium f12 btn btn-outline-secondary"
          @click="merchant_showListStaffModal = true"
        >
          Điều chuyển
        </button>
      </div>
    </div>

    <div class="p-10 card pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit="submitForm">
          <div class="form-group">
            <input
              type="text"
              v-model.trim="search.textSearch"
              class="form-control f12 hc-37 text-search"
              placeholder="Tên/Email/SĐT"
            />
          </div>
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :locale-data="localeData"
              :ranges="false"
              @update="transformDate"
              v-model="dateRange"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12"
                >
                  {{ picker.startDate | formatDate }} - {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời gian tạo
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.regionId"
              :options="dataConfigRegion"
              @change="queryProvince($event)"
              placeholder="Vùng kinh doanh"
            />
          </div>

          <div class="form-group">
            <Select2
              v-model="search.cityCode"
              :options="dataProvince"
              placeholder="Tỉnh/Thành phố"
            />
          </div>

          <div class="form-group">
            <Select2 v-model="search.channel" :options="dataSource" placeholder="Nguồn tạo" />
          </div>

          <div class="form-group">
            <Select2 v-model="search.dataSource" :options="dataChannel" placeholder="Kênh tạo" />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.customerType"
              :options="Config.customerType"
              placeholder="Loại hình DN"
            />
          </div>

          <div class="form-group">
            <Select2 v-model="search.mcc" :options="dataConfigMcc" placeholder="Ngành nghề" />
          </div>

          <div class="form-group" v-if="search.mcc">
            <Select2
              v-model="search.mccDetail"
              :options="getMccDetail(search.mcc)"
              placeholder="Ngành nghề chi tiết"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.leadExtraInfo.licenseBusiness"
              :options="systemConfig.licenseBusiness"
              placeholder="Có GP ĐKKD"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.leadExtraInfo.storeLocation"
              :options="systemConfig.storeLocation"
              placeholder="Vị trí cửa hàng"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.leadExtraInfo.ownPOS"
              :options="systemConfig.ownPOS"
              placeholder="Đã có POS?"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.leadExtraInfo.lstPos"
              :options="systemConfig.posBank"
              placeholder="POS bên nào?"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.leadExtraInfo.hasInstallment"
              :options="systemConfig.hasInstallment"
              placeholder="Có trả góp chưa?"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.leadExtraInfo.lstInstallmentBank"
              :options="systemConfig.installmentBank"
              placeholder="Trả góp bên nào?"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.leadExtraInfo.hasVietQr"
              :options="systemConfig.hasVietQr"
              placeholder="Đã có VietQR chưa?"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.leadExtraInfo.lstVietQrBank"
              :options="systemConfig.vietQrBank"
              placeholder="VietQR bên nào?"
            />
          </div>

          <div class="form-group">
            <Select2
              v-model="search.teleSaleId"
              :options="caringStaff"
              placeholder="Nhân viên tư vấn"
            />
          </div>

          <div class="form-group">
            <Select2
              v-model="search.saleId"
              :options="caringStaff"
              placeholder="Nhân viên triển khai"
            />
          </div>

          <div class="form-group" v-if="!['POTENTIAL', 'MERCHANT'].includes(search.leadType)">
            <select2-multiple-control
              v-model="search.status"
              :options="listState"
              :settings="{ placeholder: 'Trạng thái' }"
            ></select2-multiple-control>
          </div>

          <div class="form-group">
            <Select2
              v-model="search.tag"
              :options="Config.getSearch(Config.levelPotential)"
              placeholder="Mức tiềm năng"
            />
          </div>
          <div class="form-group">
            <input
              type="number"
              v-model.number="search.minScore"
              class="form-control f12 hc-37 text-search"
              placeholder="Điểm tiềm năng từ"
            />
          </div>
          <div class="form-group">
            <input
              type="number"
              v-model.number="search.maxScore"
              class="form-control f12 hc-37 text-search"
              placeholder="Điểm tiềm năng đến"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.expireSupport"
              :options="expireSupportData"
              placeholder="Tình trạng chăm sóc"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.autoGenAction"
              :options="autoGenActionData"
              placeholder="Công việc tự động"
            />
          </div>

          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              @update="transformDateCaring()"
              v-model="dateRangeCaring"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12"
                >
                  {{ picker.startDate | formatDate }} - {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời gian chăm sóc cuối
                </label>
              </template>
            </DateRangePicker>
          </div>

          <div class="form-group">
            <Select2 v-model="search.rating" :options="dataRating" placeholder="Độ ưu tiên" />
          </div>

          <div class="form-group">
            <Select2 v-model="search.agentGroup" :options="dataAgentGroup" placeholder="Nhóm CTV" />
          </div>
          <div class="form-group">
            <Select2 v-model="search.leadType" :options="listType" placeholder="Loại khách hàng" />
          </div>
          <div class="form-group form-group-action">
            <button
              @click="submitForm"
              class="pt-2 mr-2 btn btn-primary hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>
            <button
              @click="removeForm"
              type="button"
              class="pt-2 mr-2 btn btn-outline-light hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            <div
              v-if="hasDefaultFilter"
              class="mb-2 d-inline-flex align-items-center"
              style="
                background-color: #fff3e0;
                padding: 6px 12px;
                border-radius: 4px;
                font-size: 13px;
              "
            >
              <i class="bx bx-info-circle mr-1" style="color: #f57c00"></i>
              <span style="color: #e65100">Đang lọc mặc định 3 ngày gần nhất</span>
              <button
                @click="removeDefaultFilter"
                type="button"
                class="ml-2 btn-close-filter"
                style="
                  background: none;
                  border: none;
                  cursor: pointer;
                  padding: 0 4px;
                  color: #e65100;
                  font-size: 16px;
                  line-height: 1;
                "
                title="Bỏ lọc"
              >
                ×
              </button>
            </div>
            Tổng số lead:
            <span style="font-weight: 500">{{ pagination?.total?.toLocaleString('vi-VN') }}</span>
            <b-table
              hover
              sticky-header
              responsive
              :items="dataLeads"
              :fields="filterTable"
              :fixed="true"
              :bordered="true"
              :busy.sync="loading"
            >
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #head(selected)>
                <b-form-checkbox v-if="selected.length > 0" v-model="selectAll"></b-form-checkbox>
              </template>
              <template #cell(selected)="data">
                <b-form-checkbox
                  class="text-center"
                  v-model="selected"
                  :value="data.item"
                  v-if="showCheckboxItem(data.item.status)"
                  @change="checkSelectedItem(data.item.leadId)"
                ></b-form-checkbox>
              </template>
              <template #cell(createdAt)="data">
                {{ data.item.createdAt | formatDate('HH:mm, DD/MM/YYYY') }}
              </template>
              <template #cell(lead)="data">
                <div v-if="data.item.merchantName">
                  <b>{{ data.item.merchantName }}</b> &nbsp;
                </div>
                <div v-if="data.item.mobile">{{ data.item.mobile | encryptPhone }}</div>
                <div
                  v-if="
                    data.item.email && !(data.item.accIdType && data.item.accIdType === 'MOBILE')
                  "
                >
                  <a href="#">{{ data.item.email }}</a>
                </div>

                <div>
                  <span v-if="data.item.address">{{ data.item.address }} - </span
                  ><span v-if="data.item.district">{{ data.item.district }} - </span
                  >{{ data.item.city }}
                </div>
                <div v-if="data.item.tag && data.item.score > 0">
                  <span class="bage badge-pill rateLead"
                    >{{ data.item.tag | transformData(Config.tagLead) }}:
                    {{ data.item.score }}</span
                  >
                </div>
              </template>
              <template #cell(mcc)="data">
                {{ data.item.mcc | transformData(dataConfigMcc) }}
              </template>
              <template #cell(agentGroup)="data">
                <p>{{ data.item.agentGroup | transformData(dataAgentGroup) }}</p>
                <p>{{ data.item.agentEmail }}</p>
              </template>
              <template #cell(rating)="data">
                <b v-if="data.item.rating !== ''">
                  {{ data.item.rating | transformData(dataRating) }}
                </b>
              </template>
              <template #cell(regionId)="data">
                {{ data.item.regionId | transformData(dataConfigRegion) }}
              </template>
              <template #cell(create)="data">
                <div>
                  <b>Nguồn tạo</b>: {{ data.item.channel | transformData(dataSource) }}
                  <div v-if="data.item.channel === 'SALES' || data.item.channel === 'AGENCY'">
                    <p>{{ data.item.createByName }}</p>
                    <p>{{ data.item.createByEmail }}</p>
                  </div>
                </div>
                <br />
                <p v-if="data.item.dataSource != null">
                  <b>Kênh tạo</b>: {{ data.item.dataSource | transformData(dataChannel) }}
                </p>
              </template>
              <template #cell(teleSale)="data">
                <div class="text-center" v-if="data.item.teleSaleName">
                  <b>{{ data.item.teleSaleName }}</b>
                </div>
                <div class="text-center" v-if="data.item.teleSaleEmail">
                  <a href="#">{{ data.item.teleSaleEmail }}</a>
                </div>
              </template>
              <template #cell(activeSale)="data">
                <div class="text-center" v-if="data.item.activeSaleName">
                  <b>{{ data.item.activeSaleName }}</b>
                </div>
                <div class="text-center" v-if="data.item.activeSaleEmail">
                  <a href="#">{{ data.item.activeSaleEmail }}</a>
                </div>
              </template>
              <template #cell(care)="data">
                <p v-if="data.item.lastAction">
                  <b-badge class="font-size-10" pill variant="primary" size="sm">
                    <span v-html="transformActionType(data.item.lastAction)"></span>
                  </b-badge>
                </p>
                <p v-if="data.item.lastResult">
                  <b>Kết quả:</b>
                  {{ data.item.lastResult | transformData(dataResultAction) }}
                </p>
                <p v-if="data.item.lastActionDate">
                  <b>Thực hiện:</b> {{ data.item.lastActionDate | formatDate('HH:mm, DD/MM/YYYY') }}
                </p>
                <p>
                  <span
                    type="button"
                    style="text-decoration: underline; color: blue"
                    v-if="data.item.lastActionDate != null"
                    @click="getDetailHistory(data.item)"
                    href="#"
                    ><b>Xem chi tiết</b></span
                  >
                </p>
              </template>
              <template #cell(type)="data">
                <span v-if="data.item.status === 'MERCHANT'" class="badge HAS_SERVICE">
                  Merchant
                </span>
                <span v-else-if="data.item.status === 'POTENTIAL'" class="badge HAS_SERVICE">
                  KH tiềm năng
                </span>
                <span v-else class="badge HAS_SERVICE"> Leads </span>
              </template>
              <template #cell(status)="data">
                <span
                  class="badge"
                  :class="[data.item.lastResult ? data.item.lastResult : '']"
                  v-if="data.item.status === 'DELETED'"
                >
                  {{ data.item.lastResult | mapTextStatus(listState) }}
                </span>
                <span class="badge" :class="[data.item.status ? data.item.status : '']" v-else>
                  {{ data.item.status | mapTextStatus(listState) }}
                </span>
                <span v-if="data.item.autoGenAction === true" class="badge badge-primary mt-2">
                  Đã tạo công việc tự động
                </span>
                <span v-if="data.item.expireSupport === true" class="badge badge-danger mt-2">
                  Quá hạn chăm sóc
                </span>
              </template>
              <template #cell(action)="data">
                <b-dropdown class="text-center" variant="outline-light">
                  <b-dropdown-item
                    v-if="
                      dataPermission &&
                      dataPermission.includes('CNPS_CSTM_MERCHANT_DETAIL') &&
                      data.item.status === 'MERCHANT'
                    "
                    @click="detailMerchant(data.item.myNpMerchantId)"
                    >Chi tiết
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="
                      dataPermission &&
                      dataPermission.includes('CNPS_CSTM_MERCHANT_DETAIL') &&
                      data.item.status === 'POTENTIAL'
                    "
                    @click="detailPotential(data.item.myNpMerchantId)"
                    >Chi tiết
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="
                      dataPermission &&
                      dataPermission.includes('CNPS_CSTM_MERCHANT_UPDATE') &&
                      data.item.status === 'POTENTIAL'
                    "
                    @click="
                      $router.push({
                        path: `/edit-potential-customers/${data.item.myNpMerchantId}`,
                        query: { from: 'leads' },
                      })
                    "
                    >Sửa
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="
                      dataPermission &&
                      dataPermission.includes('CNPS_LEAD_VIEW') &&
                      isLead(data.item.status)
                    "
                    @click="detailLead(data.item)"
                    >Chi tiết
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="callioConfig.active === true || dataUser.username === 'haopv@yopmail.com'"
                    @click="setCurrentUserCall(data.item)"
                    ><i class="bx bx-phone"></i><span>&nbsp;</span>Gọi điện
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="
                      ((dataPermission && dataPermission.includes('CNPS_LEAD_UPDATE')) ||
                        dataUser.typeSale === 'SALE_DIRECTOR') &&
                      isLead(data.item.status) &&
                      data.item.status !== 'EXPIRED_SUPPORT' &&
                      data.item.status !== 'USED_SERVICE'
                    "
                    @click="editLead(data.item)"
                    >Sửa
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="
                      isLead(data.item.status) &&
                      ['NEW', 'NO_CARE', 'VERIFIED'].includes(data.item.status)
                    "
                    @click="redirectAddAction(data.item)"
                    >Thêm hoạt động
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="
                      isLead(data.item.status) &&
                      ['NEW', 'NO_CARE', 'VERIFIED'].includes(data.item.status)
                    "
                    @click="redirectIntoCustomer(data.item)"
                    >Chuyển thành KH
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="
                      data.item.teleSaleId === dataUser.userId &&
                      data.item.agentGroup?.includes('VCBHO') &&
                      dataPermission.includes('CNPS_LEAD_CHANGE_SHIPPING_STATUS')
                    "
                    @click="triggerModelUpdateShipping(data.item.agentId, data.item.leadId)"
                    @change="fetchData"
                    >Thêm thông tin giao hàng
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
          </div>
        </div>
        <div class="pagination-bottom">
          <b-pagination
            v-model="search.page"
            :total-rows="pagination.total"
            :per-page="search.limit"
            class="mr-2 fl-right"
          ></b-pagination>
        </div>
      </div>
    </div>

    <!-- Modal thông báo -->
    <b-modal id="modal-noti" centered v-model="notiModal">
      <template #modal-header="{ close }">
        <h5>Thông báo</h5>
        <b-button size="sm" variant="light" @click="close()">x</b-button>
      </template>
      <div class="text-center">
        <img :src="iconNoti" />
        <h2 class="py-3 f18">{{ msgNoti }}</h2>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="light" @click="cancel()"> Đóng </b-button>
      </template>
    </b-modal>

    <!-- modal thêm hành động-->
    <b-modal id="modal-addAction" centered title="Thêm hoạt động" size="lg">
      <ValidationObserver ref="leadAction">
        <form @submit.prevent="checkAddAction">
          <ValidationProvider rules="required" vid="type" name="Hình thức">
            <div class="form-group row" slot-scope="{ errors }">
              <label for class="col-sm-4 col-form-label"
                >Hình thức<span style="color: red">*</span></label
              >
              <div class="col-sm-8">
                <Select2
                  v-model="dataAddAction.type"
                  :options="dataTypeAction"
                  placeholder="Hình thức"
                />
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>
          <ValidationProvider rules="required" vid="result" name="Kết quả">
            <div class="form-group row" slot-scope="{ errors }">
              <label for class="col-sm-4 col-form-label"
                >Kết quả<span style="color: red">*</span></label
              >
              <div class="col-sm-8">
                <Select2
                  v-model="dataAddAction.result"
                  :options="dataResultAction"
                  placeholder="Kết quả"
                />
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>
          <ValidationProvider rules="required" vid="actionTime" name="Thời gian thực hiện">
            <div class="form-group row" slot-scope="{ errors }">
              <label for class="col-sm-4 col-form-label"
                >Thời gian thực hiện<span style="color: red">*</span></label
              >
              <div class="col-sm-8">
                <date-picker
                  format="dd/MM/yyyy"
                  v-model="dataAddAction.exeDate"
                  :config="optionsDatePicker"
                ></date-picker>
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>
          <ValidationProvider rules="name4" vid="note" name="Ghi chú">
            <div class="form-group row" slot-scope="{ errors }">
              <label for class="col-sm-4 col-form-label">Ghi chú</label>
              <div class="col-sm-8">
                <input
                  v-model="dataAddAction.note"
                  type="text"
                  class="form-control"
                  placeholder="Ghi chú"
                />
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>
          <addImagesWork
            @addImage="receiveImageToAdd"
            @removeImage="receiveImageToRemove"
          ></addImagesWork>
        </form>
      </ValidationObserver>
      <div style="height: 10vh">
        <p class="mt-4">
          <i
            ><span style="color: red">*</span> Để chuyển thành KH vui lòng chọn Kết quả chăm sóc là
            Phù hợp trước</i
          >
        </p>
      </div>
      <template #modal-footer="{}">
        <b-button variant="success" @click="checkAddAction()"> Lưu </b-button>
        <b-button @click="cancelAddAction()"> Huỷ </b-button>
      </template>
    </b-modal>

    <div v-if="showListCaringSale">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h5>{{ headingAssignSale }}</h5>
                  <b-button size="sm" variant="light" @click="closeModalCaringSale()"> x </b-button>
                </div>
                <div class="modal-body">
                  <div class="form-group row">
                    <div class="col-sm-12">
                      <b-input-group>
                        <b-form-input
                          v-model="searchSale.textSearch"
                          @input="fetchListSales()"
                          @keyup.enter="fetchListSales()"
                          placeholder="Tên/Email của sale"
                        ></b-form-input>
                        <b-input-group-append>
                          <b-button variant="outline-secondary" @click="fetchListSales()"
                            >Tìm kiếm</b-button
                          >
                        </b-input-group-append>
                      </b-input-group>
                    </div>
                  </div>
                  <div class="table-responsive" style="max-height: 50vh; overflow-y: auto">
                    <table class="table table-hover table-bordered">
                      <thead>
                        <tr>
                          <th></th>
                          <th>Tên Sales</th>
                          <th>Email</th>
                          <th>Tỉnh/Thành phố</th>
                        </tr>
                      </thead>
                      <tbody v-if="loadingSale">
                        <tr>
                          <td colspan="11" align="center">
                            <i class="bx bx-loader-circle bx-spin bx-rotate-90 f30"></i>
                          </td>
                        </tr>
                      </tbody>
                      <tbody v-else>
                        <tr
                          class="table-row"
                          :class="{ 'table-primary': selectedSale.includes(item.id) }"
                          v-for="(item, index) in dataSaleSelect"
                          :key="index"
                          @click="actionSelectSale(item.id)"
                        >
                          <td>
                            <b-form-checkbox
                              class="text-center"
                              v-model="selectedSale"
                              :value="item.id"
                              disabled
                            />
                          </td>
                          <td>
                            {{ item.name }}
                          </td>
                          <td>
                            {{ item.userName }}
                          </td>
                          <td>
                            {{ item.provinceName }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div>
                    <b-pagination
                      v-model="searchSale.page"
                      :total-rows="paginationSale.total"
                      :per-page="searchSale.limit"
                      @change="paginationChange"
                      class="mr-2 fl-right"
                    ></b-pagination>
                  </div>
                </div>
                <div class="modal-footer">
                  <b-button size="sm" variant="light" @click="closeModalCaringSale()">
                    Đóng
                  </b-button>
                  <b-button
                    :disabled="selectedSale.length === 0"
                    size="sm"
                    variant="primary"
                    @click="chooseAssign()"
                  >
                    Xác nhận
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <reasonWrongInfo
      :showModalReasonWrongInfo="showModalReasonWrongInfo"
      @submitReject="submitReasonWrongInfo($event)"
      @closeModal="showModalReasonWrongInfo = false"
    >
      <slot></slot>
    </reasonWrongInfo>

    <b-modal centered v-model="showModalCheckAction">
      <template #modal-header="{ close }">
        <h5>Thông báo</h5>
        <b-button size="sm" variant="light" @click="close()">x</b-button>
      </template>
      <div class="text-center">
        <img src="@/assets/img/noti-unsuccess2.svg" alt="icon-successs" />
        <h2 class="py-3 f18">{{ messNoti }}</h2>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button
          size="sm"
          variant="light"
          @click="cancel(), $bvModal.hide('modal-addAction'), (dataAddAction = {})"
        >
          Không
        </b-button>
        <b-button size="sm" variant="primary" @click="addAction"> Đồng ý </b-button>
      </template>
    </b-modal>

    <!-- modal chăm sóc cuối-->
    <b-modal id="modal-noti" centered v-model="careModal" size="lg">
      <template #modal-header="{ close }">
        <h5>Lịch sử chăm sóc</h5>
        <b-button size="sm" variant="light" @click="close()">x</b-button>
      </template>
      <div class="text-center">
        <table class="table table-hover table-bordered" style="max-height: 400px; overflow-y: auto">
          <thead class="thead-light">
            <tr>
              <th scope="col" class="text-center">TG thực hiện</th>
              <th scope="col" class="text-center">Nội dung</th>
              <th scope="col" class="text-center">Người thực hiện</th>
              <th scope="col" class="text-center">Ảnh</th>
            </tr>
          </thead>
          <tbody>
            <tr class="table-row" v-for="(item, index) in detailHistory" :key="index">
              <td class="text-center">
                {{ item.historyCreatedAt | formatDate('HH:mm DD/MM/YYYY') }}
              </td>
              <td class="text-center">
                <p>
                  <b-badge class="font-size-12" pill variant="primary" size="sm">
                    <span v-if="item.historyAction === 'CALLED'"
                      ><i class="bx bxs-phone"></i> Đã gọi điện</span
                    >
                    <span v-if="item.historyAction === 'SENT_MESS'"
                      ><i class="bx bx-message-square-dots"></i> Đã nhắn tin</span
                    >
                    <span v-if="item.historyAction === 'SENT_MAIL'"
                      ><i class="bx bx-mail-send"></i> Đã gửi email</span
                    >
                    <span v-if="item.historyAction === 'MET'"
                      ><i class="bx bx-user"></i> Đã gặp mặt tư vấn</span
                    >
                    <span v-if="item.historyAction === 'OTHER'"
                      ><i class="bx bxs-purchase-tag"></i> Việc khác</span
                    >
                  </b-badge>
                </p>
                <p>
                  Kết quả:
                  <span class="badge" :class="[item.historyResult ? item.historyResult : '']">
                    {{ item.historyResult | transformData(dataResultAction) }}
                  </span>
                </p>
                <p v-if="item.historyNote">Ghi chú: {{ item.historyNote }}</p>
              </td>
              <td class="text-center">{{ item.historyCreatedByName }}</td>
              <td class="text-center">
                <b-link
                  v-show="item.actionImgs && item.actionImgs.length > 0"
                  class="font-size-16"
                  @click="showActionImage(item)"
                >
                  Xem ảnh
                </b-link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button variant="light" @click="cancel()"> Đóng </b-button>
      </template>
    </b-modal>
    <!--Ảnh chăm sóc cuối-->
    <b-modal centered v-model="showModalActionsImages">
      <template #modal-header="{ close }">
        <h5>Ảnh</h5>
        <b-button size="sm" variant="light" @click="close()">x</b-button>
      </template>
      <div v-for="(item, index) in dataActionImage" :key="index">
        <li class="mb-2">
          <a href="#popup-slider" data-toggle="modal">
            <img :src="item" alt="" />
          </a>
        </li>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button variant="light" @click="cancel()"> Đóng </b-button>
      </template>
    </b-modal>
    <developmentStaff
      ref="developStaff"
      :showListStaff="merchant_showListStaffModal"
      @submit="merchant_assignSelectedStaff"
      @close="merchant_showListStaffModal = false"
    >
    </developmentStaff>
    <ModalUpdateShipping ref="modalUpdateShippingRef" @change="fetchData" />
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import { LeadsService } from '@/services/lead.service'
  import { StaffService } from '@/services/staff.service'
  import { mapGetters } from 'vuex'
  import prepareQueryParamsMixin from '../../mixins/prepareQueryParamsMixin'
  import 'vue-simple-suggest/dist/styles.css'
  import Config from '@/thirdParty/config'
  import moment from 'moment'
  import reasonWrongInfo from './modal-leads/reason-wrong-info.vue'
  import { CommonService } from '@/services/common.service'

  import datePicker from 'vue-bootstrap-datetimepicker'
  import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'
  import addImagesWork from './modal-leads/add-images-work.vue'
  import developmentStaff from '@/pages/potential_customers/AssignModal/developmentStaff.vue'
  import cloneDeep from 'lodash/cloneDeep'
  import { MerchantPotentialService } from '../../services/merchantPotential.service'
  import merchantMx from '../../mixins/merchantMx'
  import { AgentService } from '@/services/agent.service'
  import ModalUpdateShipping from '@/components/Merchant/ModalUpdateShipping.vue'
  import { getLastNDays } from '@/utils/util'

  const fieldsTable = [
    { key: 'selected', label: '' },
    { key: 'createdAt', label: 'Thời gian tạo' },
    { key: 'lead', label: 'Thông tin' },
    { key: 'mcc', label: 'Ngành nghề' },
    { key: 'rating', label: 'Độ ưu tiên' },
    { key: 'regionId', label: 'Vùng kinh doanh' },
    { key: 'create', label: 'Nguồn/Kênh tạo' },
    { key: 'agentGroup', label: 'Nhóm CTV' },
    { key: 'teleSale', label: 'Nhân viên tư vấn' },
    { key: 'activeSale', label: 'Nhân viên triển khai' },
    { key: 'care', label: 'Chăm sóc cuối' },
    { key: 'type', label: 'Loại khách hàng' },
    { key: 'status', label: 'Trạng thái' },
    { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' },
  ]
  export default {
    mixins: [prepareQueryParamsMixin, merchantMx],
    components: {
      developmentStaff,
      reasonWrongInfo,
      datePicker,
      addImagesWork,
      ModalUpdateShipping,
    },
    data() {
      const { from, to } = getLastNDays(3, 'date')
      return {
        Config,
        search: {
          leadExtraInfo: {},
          limit: 20,
          page: 1,
        },
        dataLeads: [],
        fieldsTable,
        filterTable: fieldsTable,
        loading: false,
        dataUser: JSON.parse(localStorage.getItem('userData')) ?? {},
        callioConfig: JSON.parse(localStorage.getItem('callioConfig')) ?? {},

        pagination: {
          total: 0,
        },
        listState: Config.leadStatus,
        listType: Config.dataWorkType,
        localeData: Config.localeData,
        dateRange: {
          startDate: from,
          endDate: to,
        },
        dateRangeCaring: {
          startDate: null,
          endDate: null,
        },
        dataConfigRegion: [],
        dataProvince: [],
        dataSource: [{ id: '0', text: 'Tất cả' }, ...Config.sourceCreate],
        caringStaff: [],
        selected: [],
        dataSaleSelect: [],
        notiModal: false,
        msgNoti: '',
        iconNoti: '',
        showListCaringSale: false,
        saleInfo: {},
        showModalReasonWrongInfo: false,
        itemLeadId: '',
        dataConfigMcc: [],
        expireSupportData: [
          { id: '0', text: 'Tất cả' },
          { id: true, text: 'Quá hạn chăm sóc' },
          { id: false, text: 'Không quá hạn chăm sóc' },
        ],
        autoGenActionData: [
          { id: '0', text: 'Tất cả' },
          { id: true, text: 'Công việc tự động' },
          { id: false, text: 'Chưa tạo công việc tự động' },
        ],
        dataTypeAction: [
          { id: 'MET', text: 'Đã gặp mặt tư vấn' },
          { id: 'CALLED', text: 'Đã gọi điện' },
          { id: 'SENT_MESS', text: 'Đã nhắn tin' },
          { id: 'SENT_MAIL', text: 'Đã gửi email' },
          { id: 'OTHER', text: 'Việc khác' },
        ],
        dataResultAction: [
          { id: 'SUITABLE', text: 'Phù hợp' },
          { id: 'MEET_FAIL', text: 'Không liên hệ được' },
          { id: 'NO_CARE', text: 'Chưa quan tâm' },
          { id: 'DUPLICATE', text: 'Trùng thông tin' },
          { id: 'WRONG', text: 'Sai thông tin' },
          { id: 'HAS_SERVICE', text: 'Đã sử dụng dịch vụ' },
          { id: 'OTHER', text: 'Khác' },
        ],
        dataAddAction: {},
        showModalCheckAction: false,
        messNoti: '',
        leadSelected: '',
        selectedSale: [],
        searchSale: {
          textSearch: '',
          // name: '',
          // email: '',
          page: 1,
          limt: 20,
        },
        paginationSale: {
          total: null,
        },
        loadingSale: false,
        dataSaleList: [],
        dataRating: [
          { id: '0', text: 'Tất cả' },
          { id: 'HOT', text: 'Ưu tiên' },
          { id: 'WARM', text: 'Thường' },
          { id: 'COLD', text: 'Không ưu tiên' },
        ],
        optionsDatePicker: {
          format: 'YYYY-MM-DD HH:mm',
          useCurrent: true,
        },
        headingAssignSale: '',
        dataImages: [],
        dataImageToAdd: [],
        showLoading: false,
        dataAgentGroup: [],

        dataChannel: [],
        checkSelectAll: false,
        detailHistory: [],
        careModal: false,
        showModalActionsImages: false,
        dataActionImage: [],
        merchant_showListStaffModal: false,
        hasDefaultFilter: true,
      }
    },
    watch: {
      'search.page': function () {
        this.$router.replace({
          query: this.useInUrlQueryPropList,
        })
        this.fetchData()
      },
    },
    created() {
      this.transformDate()
      this.fetchData()
      this.getRegions()
      this.listSaleLead()
      this.configSystem()
      this.channelSource()
      this.getConfigSystem()
      this.getListAgentGroup()
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
      useInUrlQueryPropList() {
        return this.prepareQueryParamsMixin({
          limit: this.search.limit,
          page: this.search.page,
        })
      },
      selectAll: {
        get: function () {
          return this.dataLeads ? this.selected.length === this.dataLeads.length : false
        },
        set: function (value) {
          if (value) {
            this.selected = this.dataLeads.filter(s => {
              return this.canSelectItem(s.status)
            })
            this.checkSelectAll = true
          } else this.selected = []
        },
      },
    },
    filters: {
      transformData(data, dataConfig) {
        const dataReturn = dataConfig.filter(e => e.id === data)
        if (dataReturn.length === 0) {
          return ''
        }
        return dataReturn[0].text
      },
    },
    methods: {
      triggerModelUpdateShipping(agentId, leadId) {
        this.$refs.modalUpdateShippingRef.openModal(agentId, leadId)
      },

      async getListAgentGroup() {
        try {
          const listAgent = await AgentService.getListAgentGroup()
          this.dataAgentGroup = listAgent.data.map(e => {
            return { id: e.code, text: e.name }
          })
          this.dataAgentGroup.unshift({ id: 0, text: 'Tất cả' })
        } catch (error) {
          console.log(error)
        }
      },
      // gọi điện
      setCurrentUserCall(data) {
        this.$store.commit('callio/SET_TMP_CURRENT_USER_CALL', {
          customerId: data.leadId,
          customerName: data.customerName,
          mobile: data.mobile,
          email: data.email,
          city: data.city,
          district: data.district,
        })
        this.$store.commit('callio/SET_MODAL', true)
        this.$store.commit('callio/SET_MODAL_MINI', false)
      },
      async channelSource() {
        const data = await LeadsService.channelSource()
        if (data.success) {
          for (const i in data.data) {
            this.dataChannel.push({
              id: i,
              text: data.data[i],
            })
          }
          this.dataChannel.unshift({ id: 0, text: 'Tất cả' })
        }
      },
      isLead(status) {
        return !['MERCHANT', 'POTENTIAL'].includes(status)
      },
      canSelectItem(status) {
        if (this.selected[0].status === 'MERCHANT' && status === 'MERCHANT') return true
        else if (this.selected[0].status === 'POTENTIAL' && status === 'POTENTIAL') return true
        else if (this.isLead(this.selected[0].status) && this.isLead(status)) return true
        else return false
      },
      showCheckboxItem(status) {
        if (status === 'EXPIRED_SUPPORT') return false
        if (this.selected.length > 0) {
          return this.canSelectItem(status)
        } else return true
      },
      // chi tiết
      detailLead(item) {
        window.open(`/detail-lead/${item.leadId}/view`, '_blank')
      },
      // action chăm sóc cuối
      transformActionType(item) {
        let htmlAction = ''
        switch (item) {
          case 'CALLED':
            htmlAction = '<i class="bx bxs-phone"></i> Đã gọi điện'
            break
          case 'SENT_MESS':
            htmlAction = '<i class="bx bx-message-square-dots"></i> Đã nhắn tin'
            break
          case 'SENT_MAIL':
            htmlAction = '<i class="bx bx-mail-send"></i> Đã gửi email'
            break
          case 'MET':
            htmlAction = '<i class="bx bx-user"></i> Đã gặp mặt tư vấn'
            break
          case 'OTHER':
            htmlAction = '<i class="bx bxs-purchase-tag"></i> Việc khác'
            break
          default:
            htmlAction = ''
            break
        }
        return htmlAction
      },
      // sửa
      editLead(item) {
        if (
          item.createdBy === this.dataUser.userId ||
          item.activeSaleId === this.dataUser.userId ||
          item.teleSaleId === this.dataUser.userId ||
          this.dataUser.typeSale === 'SALE_DIRECTOR'
        ) {
          this.$router.push({ path: `/edit-lead/${item.leadId}` })
        } else {
          this.notiModal = true
          this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
          this.msgNoti = 'Bạn chỉ được sửa lead của mình'
        }
      },
      // thêm hoạt động
      redirectAddAction(item) {
        if (
          item.createdBy === this.dataUser.userId ||
          item.activeSaleId === this.dataUser.userId ||
          item.teleSaleId === this.dataUser.userId ||
          this.dataUser.typeSale === 'SALE_DIRECTOR'
        ) {
          this.$router.push({ path: `/detail-lead/${item.leadId}/addAction` })
        } else {
          this.notiModal = true
          this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
          this.msgNoti = 'Bạn không được quyền thực hiện với lead của người khác'
        }
      },
      // check trạng thái -> nếu Phù hợp thì chuyển trang 'chuyển thành KH'
      redirectIntoCustomer(item) {
        if (
          item.createdBy === this.dataUser.userId ||
          item.activeSaleId === this.dataUser.userId ||
          item.teleSaleId === this.dataUser.userId ||
          this.dataUser.typeSale === 'SALE_DIRECTOR'
        ) {
          if (item.status === 'VERIFIED') {
            this.$router.push(`/auth-info/${item.leadId}/auth`)
          } else {
            // không phải trạng thái Phù hợp => mở modal thêm hđ
            this.$bvModal.show('modal-addAction')
            this.leadSelected = item.leadId
          }
        } else {
          this.showErr('Bạn không được quyền thực hiện với Lead của người khác')
        }
      },
      // check trạng thái của lead để thực hiện
      checkAddAction() {
        if (this.dataAddAction.result === 'WRONG' || this.dataAddAction.result === 'DUPLICATE') {
          this.showModalCheckAction = true
          this.messNoti = `Hệ thống sẽ chuyển Lead thành ${this.dataAddAction === 'WRONG' ? '[Sai thông tin]' : '[Trùng thông tin]'} và bạn không được thao tác gì với Lead này nữa. Bạn có chắc chắn muốn Lưu không?`
        } else {
          this.addAction()
        }
      },
      // thêm hành động
      async addAction() {
        try {
          const isSuccess = await this.$refs.leadAction.validate()
          if (!isSuccess) return

          this.showLoading = true
          this.dataImageToAdd = []
          if (this.dataImages.length > 0) await this.uploadImg()

          this.dataAddAction.exeDate = new Date(this.dataAddAction.exeDate).getTime()

          const today = new Date()
          const currentTime = today.getTime()
          if (this.dataAddAction.exeDate > currentTime) {
            this.notiModal = true
            this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
            this.msgNoti = 'Thời gian thực hiện không đúng, vui lòng chọn lại !'
            return
          }
          const response = await LeadsService.createAction({
            action: this.dataAddAction.type,
            leadId: this.leadSelected,
            exeDate: this.dataAddAction.exeDate,
            note: this.dataAddAction.note,
            result: this.dataAddAction.result,
          })
          // chuyển thành khách hàng
          if (response.code === 1000) {
            if (
              this.dataAddAction.result === 'SUITABLE' ||
              this.dataAddAction.result === 'HAS_SERVICE'
            ) {
              this.$router.push(`/auth-info/${this.leadSelected}/auth`)
              return
            }
            this.notiModal = true
            this.iconNoti = require('@/assets/img/noti-success2.svg')
            this.msgNoti = 'Thêm hoạt động thành công !'
            this.dataAddAction = {}
            this.$bvModal.hide('modal-addAction')
            await this.fetchData()
          } else {
            this.showErr(response.message)
          }
          this.showLoading = false
        } catch (error) {
          this.showLoading = false
          console.log(error)
        }
      },
      // lịch sử chăm sóc
      async getDetailHistory(item) {
        try {
          const response = await LeadsService.careHistory({
            leadId: item.leadId,
          })
          if (response.success) {
            this.detailHistory = response.data
          }
        } catch (error) {
          console.log(error)
        }
        this.careModal = true
      },
      // xem ảnh lịch sử chăm sóc
      showActionImage(item) {
        this.showModalActionsImages = true
        this.dataActionImage = item.actionImgs
      },

      // define ngày trên lịch
      transformDate() {
        this.search.startDate = moment(this.dateRange.startDate)
          .startOf('day')
          .add(7, 'hours')
          .valueOf()
        this.search.endDate = moment(this.dateRange.endDate).endOf('day').add(7, 'hours').valueOf()
      },
      transformDateCaring() {
        this.search.actionStartDate = moment(this.dateRangeCaring.startDate)
          .startOf('day')
          .add(7, 'hours')
          .valueOf()
        this.search.actionEndDate = moment(this.dateRangeCaring.endDate)
          .endOf('day')
          .add(7, 'hours')
          .valueOf()
      },

      // lấy vùng
      async getRegions() {
        const data = await StaffService.getRegions()
        if (data.data.length > 0) {
          this.dataConfigRegion.push({ id: 0, text: 'Tất cả' })
          data.data.map(e => {
            this.dataConfigRegion.push({ id: e.id, text: e.name })
          })
        }
      },
      // lấy tỉnh, tp
      async queryProvince(e) {
        try {
          const region = this.dataConfigRegion.find(a => a.id === e)
          const data = await StaffService.getProvinceRegion({ regionId: [region.id] })
          if (data.data.length > 0) {
            this.dataProvince = data.data.map(e => {
              return { id: e.code, text: e.name }
            })
          }
        } catch (error) {}
      },
      configSystem() {
        return CommonService.getConfigSystem()
          .then(data => {
            if (data.success) {
              this.dataConfigMcc.push({ id: '0', text: 'Tất cả' })
              data.data.businessFields.map(e => {
                this.dataConfigMcc.push({ id: e.code, text: e.name })
              })
            }
          })
          .catch(error => console.log(error))
      },

      async listSaleLead() {
        try {
          const data = await StaffService.getStaffByIdSuperior({
            userId: this.dataUser.userId,
          })
          if (data.data.length > 0) {
            this.caringStaff.push({ id: '0', text: 'Tất cả' })
            data.data.map(e => {
              this.caringStaff.push({ id: e.userId, text: `${e.name} - ${e.userName}` })
            })
          }
        } catch (error) {}
      },

      // Lọc
      async submitForm(event) {
        event.preventDefault()
        this.fetchData()
      },
      // Bỏ lọc
      async removeForm() {
        this.search = {
          leadExtraInfo: {},
          limit: 20,
          page: 1,
        }
        this.dateRange = {
          startDate: null,
          endDate: null,
        }
        this.dateRangeCaring = {
          startDate: null,
          endDate: null,
        }
        this.dataProvince = []
        this.selected = []
        this.hasDefaultFilter = false
        await this.fetchData()
      },
      // Bỏ lọc mặc định
      removeDefaultFilter() {
        this.search = {
          leadExtraInfo: {},
          limit: 20,
          page: 1,
        }
        this.dateRange = {
          startDate: null,
          endDate: null,
        }
        this.dateRangeCaring = {
          startDate: null,
          endDate: null,
        }
        this.dataProvince = []
        this.selected = []
        this.hasDefaultFilter = false
        this.fetchData()
      },
      // data bảng
      preareData() {
        const data = cloneDeep(this.search)

        if (data.dataSource === '0') delete data.dataSource
        if (data.channel === '0') delete data.channel
        if (data.leadExtraInfo.lstVietQrBank)
          data.leadExtraInfo.lstVietQrBank = [this.search.leadExtraInfo.lstVietQrBank]
        if (data.leadExtraInfo.lstInstallmentBank)
          data.leadExtraInfo.lstInstallmentBank = [this.search.leadExtraInfo.lstInstallmentBank]
        if (data.leadExtraInfo.lstPos)
          data.leadExtraInfo.lstPos = [this.search.leadExtraInfo.lstPos]
        if (data.regionId === '0') {
          delete data.regionId
          delete data.cityCode
          this.dataProvince = []
        }
        if (data.cityCode === '0') delete data.cityCode
        if (data.channel === '0') delete data.channel
        if (data.status === '0') delete data.status
        if (data.saleId === '0') delete data.saleId
        if (data.teleSaleId === '0') delete data.teleSaleId
        if (data.mcc === '0') delete data.mcc
        if (data.rating === '0') delete data.rating
        if (data.agentGroup === '0') delete data.agentGroup
        if (data.autoGenAction === '0') delete data.autoGenAction
        else if (data.autoGenAction === 'true' || data.autoGenAction === 'false')
          data.autoGenAction = data.autoGenAction === 'true'
        if (data.expireSupport === '0') delete data.expireSupport
        else if (data.expireSupport === 'true' || data.expireSupport === 'false')
          data.expireSupport = data.expireSupport === 'true'
        if (data.tag === '0') delete data.tag
        if (data.leadType === 'ALL') delete data.leadType
        return data
      },
      async fetchData() {
        this.selected = []
        try {
          this.loading = true
          const search = this.preareData()
          if (['POTENTIAL', 'MERCHANT'].includes(search.leadType)) delete search.status
          const data = await LeadsService.getListLeads(search)
          if (data.success) {
            this.dataLeads = data.data
            this.pagination.total = data.meta.pagination.total ? data.meta.pagination.total : 0
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },

      assignCaringSale(assignType) {
        this.assignType = assignType
        const ans = this.getSaleRegion()
        this.showListCaringSale = true

        if (assignType === 'advise') this.headingAssignSale = 'Gán nhân viên tư vấn'
        else if (assignType === 'deployment') this.headingAssignSale = 'Gán nhân viên triển khai'

        this.searchSale.userId = this.dataUser.userId
        this.searchSale.region = ans ?? []

        const sale = this.dataLeads.filter(e => e.leadId === this.selected[0].leadId)[0]
          .activeSaleId
        this.selectedSale = [sale]

        this.getListStaffLower(this.searchSale)
        // }
      },

      getSaleRegion() {
        const arr = this.selected.map(e => {
          return e.regionId
        })
        const isExist = (arr, x) => {
          for (const i in arr) {
            if (arr[i] === x) return true
          }
          return false
        }
        const ans = []
        arr.forEach(element => {
          if (!isExist(ans, element)) ans.push(element)
        })
        return arr
      },
      async merchant_assignSelectedStaff(data) {
        this.merchant_showListStaffModal = false
        try {
          this.showLoading = true
          const response = await MerchantPotentialService.assignDeploymentStaff({
            customerIds: this.selected.map(s => s.myNpMerchantId),
            saleId: data.userId.length > 0 ? data.userId[0] : '',
          })
          if (response.code === 1000) {
            this.notiModal = true
            this.iconNoti = require('@/assets/img/noti-success2.svg')
            this.msgNoti = `Gán ${this.selected.length} ${this.selected[0].status === 'POTENTIAL' ? 'khách hàng tiềm năng' : 'merchant'} cho ${data.dataSale[0].name} thành công`
            this.selected = []
            await this.fetchData()
            setTimeout(() => {
              this.notiModal = false
            }, 1500)
          } else {
            this.showErr(response.message)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      chooseAssign() {
        if (this.assignType === 'advise') this.chooseAssignCaringSale()
        else this.chooseActiveSale()
      },

      async chooseAssignCaringSale() {
        const leadIds = []
        this.selected.map(e => leadIds.push(e.leadId))
        try {
          const data = await LeadsService.assignTeleSale({
            leadIds: leadIds,
            teleSaleId: this.selectedSale[0],
          })
          if (data.success) {
            this.showListCaringSale = false
            this.notiModal = true
            this.iconNoti = require('@/assets/img/noti-success2.svg')
            this.msgNoti = data.message
            this.selected = []
            this.showListCaringSale = false
            await this.fetchData()
          } else {
            this.showListCaringSale = false
            this.showErr(data.message)
            this.selected = []
            await this.fetchData()
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.selected = []
        }
      },

      async chooseActiveSale() {
        const leadIds = []
        this.selected.map(e => leadIds.push(e.leadId))
        try {
          const data = await LeadsService.assignActiveSale({
            leadIds: leadIds,
            saleId: this.selectedSale[0],
          })
          if (data.success) {
            this.showListCaringSale = false
            this.notiModal = true
            this.iconNoti = require('@/assets/img/noti-success2.svg')
            this.msgNoti = data.message
            this.selected = []
            this.showListCaringSale = false
            await this.fetchData()
          } else {
            this.showListCaringSale = false
            this.showErr(data.message)
            this.selected = []
            await this.fetchData()
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.selected = []
        }
      },

      async convertIntoCustomer(item) {
        try {
          const serviceList = []
          if (item.suggestServiceList && item.suggestServiceList.length) {
            item.suggestServiceList.map(e => {
              if (e.serviceList) serviceList.push(e.serviceType)
            })
          }
          const body = {
            address: item.address ? item.address : '',
            allowSave: true,
            city: item.city,
            cityCode: item.cityCode,
            customerName: item.customerName,
            customerType: item.customerType ? item.customerType : '',
            description: item.description,
            district: item.district,
            districtCode: item.districtCode,
            email: item.email,
            merchantName: item.merchantName ? item.merchantName : '',
            mobile: item.mobile,
            suggestServiceList: serviceList.length !== 0 ? serviceList : item.suggestServiceList,
            uploadImages: item.uploadImages,
            verify: true,
          }
          const response = await LeadsService.authLead(body)
          if (response.code === 1000) {
            this.$router.push(`/auth-info/${item.leadId}/auth`)
          } else {
            this.showErr(response.message)
          }
        } catch (error) {
          console.log(error)
        }
      },

      pushWrongInfo(item) {
        this.showModalReasonWrongInfo = true
        this.itemLeadId = item.leadId
      },
      async submitReasonWrongInfo(event) {
        try {
          const response = await LeadsService.updateWrongInfo({
            leadId: this.itemLeadId,
            reason: event.reasonWrong,
          })
          if (response.code === 1000) {
            this.notiModal = true
            this.iconNoti = require('@/assets/img/noti-success2.svg')
            this.msgNoti = 'Cập nhật thông tin sai thành công !'
            await this.fetchData()
          } else {
            this.showErr(response.message)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showModalReasonWrongInfo = false
        }
      },

      async duplicateInfo(item) {
        try {
          const response = await LeadsService.updateDuplicateInfo({
            leadId: item.leadId,
          })
          if (response.code === 1000) {
            this.notiModal = true
            this.iconNoti = require('@/assets/img/noti-success2.svg')
            this.msgNoti = 'Cập nhật trùng thông tin thành công !'
            await this.fetchData()
          } else {
            this.showErr(response.message)
          }
        } catch (error) {
          console.log(error)
        }
      },

      showErr(message) {
        this.notiModal = true
        this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
        this.msgNoti = message
      },

      cancelAddAction() {
        this.dataAddAction = {}
        this.$bvModal.hide('modal-addAction')
      },

      fetchListSales() {
        if (this.searchSale.textSearch === '') {
          this.searchSale = {
            userId: this.dataUser.userId,
          }
        }
        this.searchSale.userId = this.dataUser.userId
        this.searchSale.region = this.getSaleRegion()
        this.getListStaffLower(this.searchSale)
      },
      // list sale lead gán
      async getListStaffLower(params) {
        const body = {
          page: params.page,
          size: 1000,
          regions: params.region,
          key: params.textSearch,
          typeSales: [
            'SALE_DIRECTOR',
            'REGION_DIRECTOR',
            'SALE_ADMIN',
            'SALE_MANAGER',
            'SALE_LEADER',
            'AFTER_SALE_LEADER',
            'TELESALE_LEADER',
            'TRAINER_LEADER',
            'SALE',
            'AFTER_SALE',
            'TELESALE',
            'COOPERATOR',
            'ACCOUNT_MANAGER',
            'AFTER_SALE_OFFLINE',
          ],
        }
        try {
          this.loadingSale = true
          const data = await StaffService.getListByRegionTypeSale(body)
          if (data.data.length > 0) {
            this.dataSaleList = data.data
            this.paginationSale.total = data.data.length
            this.searchSale.limit = 20
            this.paginationChange(1)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loadingSale = false
        }
      },

      async paginationChange(pageIndex) {
        this.searchSale.page = pageIndex
        this.dataSaleSelect = []
        const mod = this.paginationSale.total % this.searchSale.limit
        if (
          mod === 0 ||
          (pageIndex - 1) * this.searchSale.limit < this.paginationSale.total - mod
        ) {
          for (
            let i = (pageIndex - 1) * this.searchSale.limit;
            i < pageIndex * this.searchSale.limit;
            i++
          ) {
            this.dataSaleSelect.push(this.dataSaleList[i])
          }
        } else {
          for (let i = this.paginationSale.total - mod; i < this.paginationSale.total; i++) {
            this.dataSaleSelect.push(this.dataSaleList[i])
          }
        }
      },

      actionSelectSale(item) {
        this.selectedSale = []
        this.selectedSale.push(item)
        this.selectedSale = this.selectedSale.filter(e => e === item)
      },

      selectToAssign(item) {
        if (!this.selected.includes(item)) this.selected.push(item)
        else this.selected = this.selected.filter(e => e !== item)
      },

      closeModalCaringSale() {
        this.showListCaringSale = false
        this.selected = []
        this.selectedSale = []
      },

      async receiveImageToAdd(data) {
        this.dataImages = data
      },
      receiveImageToRemove(index) {
        this.dataImages.splice(index, 1)
      },
      async uploadImg() {
        try {
          for (let index = 0; index < this.dataImages.length; index++) {
            const element = this.dataImages[index]
            await CommonService.uploadImg(element).then(res => {
              if (res.code === 1000) {
                this.dataImageToAdd.push(res.data[0])
              }
            })
          }
        } catch (error) {
          console.log('add img reader', error)
        }
      },

      checkSelectedItem(leadId) {
        if (this.checkSelectAll && this.selected.length === 0) {
          const selected = []
          this.dataLeads.forEach(item => {
            if (item.leadId !== leadId) selected.push(item)
          })
          this.selected = selected
        }
        if (this.selected.length !== 0) this.checkSelectAll = false
      },
      async exportExcel() {
        try {
          this.showLoading = true
          if (this.search.dataSource === '0') delete this.search.dataSource
          if (this.search.channel === '0') delete this.search.channel
          if (this.search.regionId === '0') delete this.search.regionId
          if (this.search.cityCode === '0') delete this.search.cityCode
          if (this.search.channel === '0') delete this.search.channel
          if (this.search.status === '0') delete this.search.status
          if (this.search.saleId === '0') delete this.search.saleId
          if (this.search.teleSaleId === '0') delete this.search.teleSaleId
          if (this.search.mcc === '0') delete this.search.mcc
          if (this.search.rating === '0') delete this.search.rating
          if (this.search.agentGroup === '0') delete this.search.agentGroup

          await LeadsService.exportExcel(this.search)
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      detailMerchant(id) {
        window.open(`/list-mc/${id}?from=leads`)
      },
      detailPotential(id) {
        window.open(`/detail-potential-customers/${id}?from=leads`)
      },
    },
  }
</script>
